import type { GridBox } from "@reco/shared/src/types/gridbox";

export function getProductTitleFromURL(): string {
  const route = useRoute();
  const urlPathArr = route.path.split("/");
  const urlProductTitle = urlPathArr.at(-2) || "";

  return urlProductTitle
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function getProductGridboxUrl(host: string, country: string, language: string, erpNumber: string) {
  return `${host}/p/api/gridboxes/${country}/${language}?erpNumbers=${erpNumber}`;
}

export function mapToErpNumber(gridboxes: GridBox[]) {
  return gridboxes.map((item) => item["erpNumber"]);
}
